var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MTableCell',{staticClass:"m-table-cell__default",on:{"click":function($event){return _vm.$emit('click-trigger')}}},[_c('div',{staticClass:"m-table-cell__ellipsis-wrapper",attrs:{"title":_vm.value}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }